module.exports = __webpack_public_path__ + "media/images/icons/filled/yahoo-db3fc745c8cd25f6a39447e948ceb24c.svg";